import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Observable, map, take } from 'rxjs';

import { WindowRef, SentryLogger } from '@fcom/core';

import { MultivariateTestService } from '../../multivariate-test/services/multivariate-test.service';

export enum HotjarCaptureEvent {
  BOOKING_WIDGET = 'start_capture-booking_widget',
}

export enum HotjarAction {
  EVENT = 'event',
  IDENTIFY = 'identify',
}

@Injectable()
export class HotjarService {
  private captureStarted = false;

  constructor(
    private windowRef: WindowRef,
    private sentryLogger: SentryLogger,
    private multivariateTestService: MultivariateTestService,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  startCapture(event: HotjarCaptureEvent): Observable<void> {
    return this.multivariateTestService.segmentsFeed$.pipe(
      take(1),
      map((segment) => {
        if (this.captureStarted || isPlatformServer(this.platform)) {
          return;
        }

        this.executeAction(HotjarAction.IDENTIFY, null, {
          segment: segment.segment,
        });

        this.executeAction(HotjarAction.EVENT, event);

        this.captureStarted = true;
      })
    );
  }

  private executeAction(action: HotjarAction, ...params: any[]): void {
    const hotjar = this.windowRef.nativeWindow['hj'];

    if (typeof hotjar === 'function') {
      try {
        hotjar(action, ...params);
      } catch (error) {
        this.sentryLogger.warn('Failed to start hotjar capture', { error });
      }
    }
  }
}
